(function () {
  'use strict';

  function initRoot(root) {
    if (root.dataset.lmCommunityClipsReady === 'true') return;
    var track = root.querySelector('.lm-community-clips__track');
    var nextBtn = root.querySelector('[data-lm-community-next]');
    if (!track) return;
    root.dataset.lmCommunityClipsReady = 'true';

    function scrollNext() {
      var item = track.querySelector('.lm-community-clips__item');
      if (!item) return;
      var gap = parseFloat(getComputedStyle(track).gap) || 8;
      track.scrollBy({ left: item.offsetWidth + gap, behavior: 'smooth' });
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', scrollNext);
    }

    function updateArrow() {
      if (!nextBtn) return;
      var maxScroll = track.scrollWidth - track.clientWidth - 2;
      nextBtn.style.opacity = track.scrollLeft >= maxScroll ? '0.35' : '1';
      nextBtn.disabled = track.scrollLeft >= maxScroll;
    }

    track.addEventListener('scroll', updateArrow, { passive: true });
    window.addEventListener('resize', updateArrow, { passive: true });
    updateArrow();
  }

  function boot() {
    document.querySelectorAll('[data-lm-community-clips]').forEach(initRoot);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', boot);
})();
